import { SCREENS } from "utils/constants";
import List from "./List";
import Create from "./Create";
import Detail from "./Detail";
import Delete from "./Delete";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.SCREEN_STUDIOS.LIST.path,
    exact: true,
    element: <List />,
  },
  {
    path: SCREENS.PRIVATE.ADMIN.SCREEN_STUDIOS.CREATE.path,
    element: <Create />,
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.SCREEN_STUDIOS.DETAIL.path}/:id`,
    element: <Detail />,
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.SCREEN_STUDIOS.DELETE.path}/:id`,
    element: <Delete />,
  },
];

export default routes;
